import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, Switch, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';
import { t } from '../../i18n';

export const AppUpdateCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/app-updates',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title={t('appUpdates.new')}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('appUpdates.version')}
                  help="Yangilanish versiyasi va sozlamalari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('appUpdates.version')}
                    help="pubspec.yaml dagi version bilan bir xil bo'lishi kerak (masalan: 1.2.0)"
                  />
                }
                name="version"
                rules={[
                  { required: true, message: 'Versiyani kiriting' },
                  {
                    pattern: /^\d+\.\d+\.\d+$/,
                    message: 'Format: 1.2.3 (masalan: 1.0.0)',
                  },
                ]}
              >
                <Input placeholder="1.2.0" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('appUpdates.mandatory')}
                    help="Yoqilsa, foydalanuvchi yangilanmasdan ilovadan foydalana olmaydi. Katta o'zgarishlar uchun yoqing."
                  />
                }
                name="isMandatory"
                valuePropName="checked"
                initialValue={false}
              >
                <Switch checkedChildren="Majburiy" unCheckedChildren="Ixtiyoriy" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('common.active')}
                    help="Faol bo'lsa, foydalanuvchilarga ko'rinadi. O'chiq bo'lsa, hech kimga ko'rinmaydi."
                  />
                }
                name="isActive"
                valuePropName="checked"
                initialValue={true}
              >
                <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('appUpdates.storeUrls')}
                  help="Play Store va App Store dagi ilova sahifasi havolalari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('appUpdates.playStoreUrl')}
                    help="Google Play Console dan ilovaning ochiq havolasini ko'chiring"
                  />
                }
                name="playStoreUrl"
                rules={[{ required: true, message: 'Play Store havolasini kiriting' }]}
              >
                <Input placeholder="https://play.google.com/store/apps/details?id=uz.safaro.app" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('appUpdates.appStoreUrl')}
                    help="App Store Connect dan ilovaning ochiq havolasini ko'chiring"
                  />
                }
                name="appStoreUrl"
                rules={[{ required: true, message: 'App Store havolasini kiriting' }]}
              >
                <Input placeholder="https://apps.apple.com/app/safaro/id123456789" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="O'zbekcha"
                  help="Yangilanish izohlari o'zbek tilida"
                />
              }
            >
              <Form.Item
                label={<LabelWithHelp label={t('appUpdates.releaseNotesUz')} help="Nima yangilandi? Foydalanuvchiga ko'rinadigan matn." />}
                name="releaseNotesUz"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="Yangi xususiyatlar qo'shildi va xatolar tuzatildi" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="Ruscha"
                  help="Yangilanish izohlari rus tilida"
                />
              }
            >
              <Form.Item
                label={<LabelWithHelp label={t('appUpdates.releaseNotesUz')} help="Ruscha tarjimasi" />}
                name="releaseNotesRu"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="Добавлены новые функции и исправлены ошибки" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title={
                <SectionTitle
                  title="Inglizcha"
                  help="Yangilanish izohlari ingliz tilida"
                />
              }
            >
              <Form.Item
                label={<LabelWithHelp label={t('appUpdates.releaseNotesUz')} help="Inglizcha tarjimasi" />}
                name="releaseNotesEn"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} placeholder="New features added and bugs fixed" />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
